import React from "react";

const TableHead = ({
  className,
  id,
  children,
  ...props
}) => {
    return (
        <thead
            id={id}
            className={className}
            {...props}
        >
        {children}
        </thead>
    );
};

export default TableHead;